import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

export type SaveStatus = 'idle' | 'saving' | 'saved' | 'error';

export interface SaveIndicatorProps {
  status: SaveStatus;
}

export const SaveIndicator: React.FC<SaveIndicatorProps> = ({ status }) => {
  if (status === 'idle') return null;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {status === 'saving' && (
        <>
          <CircularProgress size={16} />
          <Typography variant="caption" color="text.secondary">Saving...</Typography>
        </>
      )}
      {status === 'saved' && (
        <>
          <CloudDoneIcon color="success" sx={{ fontSize: 18 }} />
          <Typography variant="caption" color="success.main">Saved</Typography>
        </>
      )}
      {status === 'error' && (
        <>
          <CloudUploadIcon color="error" sx={{ fontSize: 18 }} />
          <Typography variant="caption" color="error.main">Auto-save failed</Typography>
        </>
      )}
    </Box>
  );
};
